import { deleteHttp, getHttp, postHttp, putHttp } from "shared/plugins/http-service";
import {
  CUSTOMER_ADDRESS_API
} from "shared/constants/api-endpoint";
import { CustomerAddressModel } from "./customer-address.models";

export const createCustomerAddressApi = async (
  customerAddressModel: CustomerAddressModel
) => {
  const response = await postHttp<number>(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ADDRESS_API}`,
    customerAddressModel
  );
  return response;
};
export const getAllCustomerAddressApi = async () => {
  const response = await getHttp<CustomerAddressModel[]>(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ADDRESS_API}`
  );
  return response;
};
export const getCustomerAddressApi = async (id: string | number) => {
  const response = await getHttp<CustomerAddressModel>(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ADDRESS_API}/${id}`
  );
  return response;
};
export const updateCustomerAddressApi = async (customerAddressModel: CustomerAddressModel) => {
  const response = await putHttp(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ADDRESS_API}`,
    customerAddressModel
  );
  return response;
};
export const removeCustomerAddressApi = async (id: string | number) => {
  const response = await deleteHttp(
    `${process.env.REACT_APP_API_URI}${CUSTOMER_ADDRESS_API}/${id}`);
  return response;
};

